if (typeof window !== 'undefined' && !window.process) {
    window.process = {
        env: {
            NODE_ENV: process.env.NODE_ENV,
            REACT_APP_RECAPTCHA: process.env.REACT_APP_RECAPTCHA,
            REACT_APP_URL_API: process.env.REACT_APP_URL_API,
            REACT_APP_URL_IMAGE: process.env.REACT_APP_URL_IMAGE,
            REACT_APP_URL_STORAGE: process.env.REACT_APP_URL_STORAGE,
            REACT_APP_URL_UPLOAD: process.env.REACT_APP_URL_UPLOAD,
            REACT_APP_URL_GRAPHQL: process.env.REACT_APP_URL_GRAPHQL,
            REACT_APP_ENV: process.env.REACT_APP_ENV,
            PUBLIC_URL: process.env.PUBLIC_URL,
        },
    };
}
